import { useMemo } from "react";
import lcmApiClient, { lcmApiClientWithVersion } from "../api/lcmApiClient";
import type { ApiVersion } from "../types/api/ApiVersion";
import { useApiWithClient } from "./useApiWithClient";

export const useApi = (version: ApiVersion = "v1") => {
  const client = useMemo(
    () =>
      version === "v1"
        ? lcmApiClient(true, true)
        : lcmApiClientWithVersion(true, true, true, version),
    [version],
  );
  return useApiWithClient(client, "hub");
};
